<div [class]="'min-h-screen flex relative ' + (sidebarVisible ? 'sidebar-visible' : '')">
  <!-- SIDEBAR -->
  <p-drawer id="app-sidebar-1" [(visible)]="sidebarVisible" [dismissible]="false" [modal]="false" [baseZIndex]="1" [closeOnEscape]="false">
    <ng-template pTemplate="header">
      <div class="acted-logo flex-shrink-0" (dblclick)="gitVersionsVisible = true">
        <a [routerLink]="['/']">
          <img src="assets/icons/acted-white.svg" alt="Acted" i18n-alt="@@sidebar-logo_alt" style="height: 60px;">
        </a>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="flex flex-column h-full">
        <div class="overflow-y-auto p-3 mt-0 mx-0 mb-7 sidebar-scroller">
          <!-- LOOP OVER LEVEL 0 MENU BUTTONS -->
          @for (level0 of menuNodes; track $index) {
            <!-- IF USER HAS LEVEL 0 PERMISSION -->
            @if (userService.hasPermissionIn(level0.data.hasPermissionIn)) {
              <ul class="list-none p-0 mt-0 overflow-hidden sidebar-ul test-level0" [ngClass]="level0.data.negativeStyle ? 'negative-style' : ''">
                <li class="test-level0">
                  <!-- SIMPLE BUTTON IF NO CHILDREN -->
                  @if (!level0.children || level0.children.length === 0) {
                    <a pRipple
                      class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                      [routerLink]="level0.data.routerLink" [queryParams]="level0.data.queryParams || {}"
                      [ngClass]="(currentUrlRoot === '/') ? 'router-link-active' : ''">
                      <i [class]="'sidebar-icon fa ' + level0.data.iconClass"></i>
                      <span class="font-medium">{{level0.label}}</span>
                    </a>
                  }
                  <!-- END SIMPLE BUTTON IF NO CHILDREN -->
                  <!-- PARENT BUTTON IF CHILDREN -->
                  @if (level0.children) {
                    <a pRipple
                      class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors no-text-decoration menu-link"
                      pStyleClass="@next" enterFromClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
                      leaveActiveClass="slideup">
                      <i [class]="'sidebar-icon fa ' + level0.data.iconClass"></i>
                      <span class="font-medium">{{level0.label}}</span>
                      <i class="fa fa-solid fa-chevron-down ml-auto"></i>
                    </a>
                  }
                  <!-- END PARENT BUTTON IF CHILDREN -->
                  <ul
                    class="list-none py-0 pl-3 pr-0 m-0 mr-3 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out test-level1"
                    [ngClass]="initialRouteWasInGroup(level0.data.initialRouteGroup) ? '' : 'hidden'">
                    <!-- LOOP OVER LEVEL 1 MENU BUTTONS -->
                    @for (level1 of level0.children; track $index) {
                      <li class="test-level1">
                        <!-- IF USER HAS PERMISSION FOR LEVEL 1 -->
                        @if (userService.hasPermissionIn(level1.data.hasPermissionIn)) {
                          <!-- SIMPLE BUTTON IF NO CHILDREN -->
                          @if (!level1.children) {
                            <a pRipple
                              class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                              [routerLink]="level1.data.routerLink" [queryParams]="level1.data.queryParams || {}"
                              [ngClass]="(currentUrlRoot.startsWith(level1.data.currentUrlRoot)) ? 'router-link-active' : ''">
                              <i [class]="'sidebar-icon fa ' + level1.data.iconClass"></i>
                              <span class="font-medium">{{level1.label}}</span>
                            </a>
                          }
                          <!-- END SIMPLE BUTTON IF NO CHILDREN -->
                          <!-- PARENT BUTTON IF CHILDREN -->
                          @if (level1.children && level1.children.length > 0) {
                            <a pRipple
                              class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors no-text-decoration menu-link"
                              pStyleClass="@next" enterFromClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
                              leaveActiveClass="slideup">
                              <span class="font-medium">{{level1.label}}</span>
                              <i class="fa fa-solid fa-chevron-down ml-auto"></i>
                            </a>
                            <ul
                              class="list-none py-0 pl-3 pr-0 m-0 mr-3 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out test-level2"
                              [ngClass]="initialRouteWasInGroup(level1.data.initialRouteGroup) ? '' : 'hidden'">
                              <!-- LOOP OVER LEVEL 2 MENU BUTTONS -->
                              @for (level2 of level1.children; track $index) {
                                <li class="test-level2">
                                  @if (userService.hasPermissionIn(level2.data.hasPermissionIn)) {
                                    <a pRipple
                                      class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                                      [routerLink]="level2.data.routerLink" [queryParams]="level2.data.queryParams || {}"
                                      [ngClass]="(currentUrlRoot.startsWith(level2.data.currentUrlRoot)) ? 'router-link-active' : ''">
                                      <span class="font-medium">{{level2.label}}</span>
                                    </a>
                                  }
                                </li>
                              }
                              <!-- END LOOP OVER LEVEL 2 MENU BUTTONS -->
                            </ul>
                          }
                          <!-- END PARENT BUTTON IF CHILDREN -->
                        }
                        <!-- END IF USER HAS PERMISSION FOR LEVEL 1 -->
                      </li>
                    }
                    <!-- END LOOP OVER LEVEL 1 MENU BUTTONS -->
                  </ul>
                </li>
              </ul>
            }
            <!-- END IF USER HAS LEVEL 0 PERMISSION -->
          }
          <!-- END LOOP OVER LEVEL 0 MENU BUTTONS -->

          @if (!user.anonymous) {
            <app-drafts uniqueKey="draftsList"></app-drafts>
          }
        </div>
      </div>

      <!-- add language switcher -->
      <div class="footer">
        <div class="centered flex justify-content-center align-items-center language-switch-menu">
          <p-selectButton #languageSwitcher [options]="languageOptions" [ngModel]="locale" optionLabel="label"
            optionValue="value" (onChange)="onChangeLang($event)" />
          @if (user.email) {
            <p-button (onClick)="onClickLogout()" icon="fa fa-solid fa-arrow-right-from-bracket" severity="secondary" class="logout ml-3"/>
          }
          @if ((networkService.online$ | async) === false) {
            <div>
              <p-tag icon="fa fa-solid fa-cloud" severity="warn" i18n-title="@@topbar-offline" title="No internet connection" class="topbar-tags"></p-tag>
            </div>
          }
        </div>
      </div>

    </ng-template>
  </p-drawer>

  @if (!sidebarVisible) {
    <div class="hamburger-div">
      <a pRipple class="cursor-pointer inline-flex align-items-center justify-content-center" (click)="sidebarVisible = true">
        <i class="fa fa-solid fa-bars text-4xl"></i>
      </a>
    </div>
  }

  <!-- END SIDEBAR -->
  <div class="min-h-screen flex flex-column relative flex-auto">
    <div class="pr-3 pl-3 flex flex-column flex-auto router-outlet-container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="long-running-jobs-container">
    @for (job of longRunningJobs; track job.code) {
      <app-long-running-jobs-detail [job]="job"></app-long-running-jobs-detail>
    }
  </div>

  @if (appEnvironment !== 'production') {
    <div class='watermark'>TEST</div>
  }

  <p-toast></p-toast>

  <p-confirmDialog header="" icon="fa fa-solid fa-triangle-exclamation" [closable]="false"></p-confirmDialog>

  <p-dialog header="Git !" [(visible)]="gitVersionsVisible" [style]="{width: '30vw'}">
    <h3>Front Archive</h3>
    <div>
      <a [href]="'https://github.com/actedparis/acted-archives/commit/' + theEnvironment.actedArchivesCommitSha.slice(0, 7)" target="_blank" rel="noopener noreferrer">
        {{ theEnvironment.actedArchivesCommitSha.slice(0, 7) }}
      </a>
    </div>
  </p-dialog>

</div>
